import script from "./SearchPotentialCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPotentialCustomerModal.vue?vue&type=script&setup=true&lang=js"

import "./SearchPotentialCustomerModal.vue?vue&type=style&index=0&id=cc21cce4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc21cce4"]])

export default __exports__